import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ResumeNew.css";

function ResumeNew() {
  const GENERAL_APPLICATION_SRC =
    "https://airtable.com/embed/appSv7F1U4nnF2KQK/pagdWExc2S10r8QCz/form";
  const HUMAN_PHYSIOLOGICAL_SRC =
    "https://airtable.com/embed/appSFJc6lbItZMYQo/pagd1MdXFTsNIysOy/form";

  return (
    <div className="w-100" style={{ overflowX: "hidden" }}>
      <Container fluid className="resume-section px-0">
        <Container>
          <div className="section-shell mb-4">
            <div className="section-intro">
              <span className="section-eyebrow">Application</span>
              <h1 className="project-heading">
                Apply for support through Shared Success Foundation.
              </h1>
              <p className="project-copy">
                The grant application period will be open from June 1, 2026 to
                August 1, 2026. We encourage all interested churches to apply
                during this period. See below for more information!
              </p>
            </div>
          </div>
        </Container>

        <Row
          className="justify-content-center"
          style={{ position: "relative", zIndex: 2 }}
        >
          <Col xl={8} lg={9} md={10} sm={11} className="px-3">
            <div className="form-shell">
              <h2 className="grant-title">
                Entrepreneurial, Career, and Life Skills Grant
              </h2>

              <div className="form-fallback">
                <p className="mb-2">
                  <strong>Having trouble viewing the application?</strong> Some
                  browsers and ad blockers prevent embedded forms from loading.
                  Click below to open the application in a new tab.
                </p>

                <a
                  href={GENERAL_APPLICATION_SRC}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Open Application
                </a>
              </div>

              <iframe
                title="General Application"
                src={GENERAL_APPLICATION_SRC}
                className="form-iframe"
                loading="lazy"
                allowFullScreen
              />
            </div>
          </Col>
        </Row>

        <Row
          className="justify-content-center mt-4"
          style={{ position: "relative", zIndex: 2 }}
        >
          <Col xl={8} lg={9} md={10} sm={11} className="px-3">
            <div className="form-shell">
              <h2 className="grant-title">
                Human Physiological Grant
              </h2>

              <div className="form-fallback">
                <p className="mb-2">
                  <strong>Having trouble viewing the application?</strong> Some
                  browsers and ad blockers prevent embedded forms from loading.
                  Click below to open the application in a new tab.
                </p>

                <a
                  href={HUMAN_PHYSIOLOGICAL_SRC}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Open Application
                </a>
              </div>

              <iframe
                title="Human Physiological Grant Application"
                src={HUMAN_PHYSIOLOGICAL_SRC}
                className="form-iframe"
                loading="lazy"
                allowFullScreen
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
